import React, { Component } from 'react';
import classnames from 'classnames';
import { Animate } from 'react-move';
import { Link } from 'react-router-dom';
import Header from '../Header';
import Notes from '../Notes';
import Steps from '../Steps';
import GCContainer from '../GCContainer';
import ControlSizeOrBikeCount from '../Controls/ControlSizeOrBikeCount';
import ControlLayout from '../Controls/ControlLayout';
import ControlRacks from '../Controls/ControlRacks';
import ControlBigButton from '../Controls/ControlBigButton';
import ResultsSummaryCard from '../Results/ResultsSummaryCard';
import Scene from '../Results/Scene';
import UIControls from '../Results/UIControls';
import UIScalar from '../Results/UIControls/size';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import DoubleDockerUnit from './svg/double_docker_unit';
import LayoutTabloid from './svg/layout_tabloid';
import RenderComponent from '../Configuration/Render';
import scrollIntoView from 'scroll-into-view-if-needed';
import { Waypoint } from 'react-waypoint';
import MobileDetect from 'mobile-detect';
import MediaQuery from 'react-responsive';

const md = new MobileDetect(window.navigator.userAgent);
const isMobile = !!md.mobile();

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 0,
      stepScrolled: false,
      scrolling: false,
      disableWaypoint: false,
      fromSteps: true
    };
  }

  componentDidMount() {
    this.props.actions.updateConfiguration();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.step !== this.state.step && this.state.step === 0) {
      this.handleScroll('controlBikes');
    }
  }
  mapNameToType = (value) => {
    switch (value) {
      case 'Double Double':
        return 'maxDensity';
      case 'Vertical Double':
        return 'balancedVerticalDouble';
      case 'Varsity Double':
        return 'balancedVarsityDouble';
      case 'Varsity Vertical':
        return 'balancedVarsityVertical';
      default:
        return 'maxDensity';
    }
  };

  handleStepSet = (step, scrolling = false, fromSteps = true) => {
    this.setState(
      {
        step,
        disableWaypoint: true,
        fromSteps
      },
      this.handleScroll
    );
  };

  handleNext = () => {
    let stp = this.state.step + 1;
    if (this.state.step === 1) {
      if (this.props.parameters.configuration === 'Rider Friendly') {
        stp++;
      }
    }
    this.setState({ step: stp, fromSteps: true }, this.handleScroll);
    // console.log(this.controlLayout);
  };

  scrollKey = (step) => {
    switch (step) {
      case 0:
        return 'controlBikes';
      case 1:
        return 'controlLayout';
      case 2:
        return 'controlRacks';
      case 3:
        return 'renderResults';
      case 4:
        return 'renderScene';
      default:
        return 'controlBikes';
    }
  };

  handleScroll = (node) => {
    if (this.state.fromSteps) {
      scrollIntoView(this[this.scrollKey(this.state.step)], {
        behavior: 'smooth',
        block: 'start',
        inline: 'center'
      });
    }
  };

  handlePrev = () => {
    let stp = this.state.step - 1;
    if (this.state.step === 3) {
      if (this.props.parameters.configuration === 'Rider Friendly') {
        stp--;
      }
    }
    this.setState({ step: stp, fromSteps: true }, this.handleScroll);
  };

  render() {
    const { step, stepScrolled, scrolling, disableWaypoint } = this.state;
    const {
      parameters,
      parameters: {
        configuration,
        rack,
        uxPath,
        bikeConfiguration,
        marginAdds,
        pastWidth,
        pastLength
      }
    } = this.props;
    const {
      className,
      parameters: { width, length, count },
      ...props
    } = this.props;
    const multiplier = 12;
    const w = width * multiplier + 'pt';
    const l = length * multiplier + 'pt';

    return Object.keys(bikeConfiguration).length > 0 ? (
      <div>
        <Header />

        <Steps
          parameters={parameters}
          handleNext={this.handleNext}
          handlePrev={this.handlePrev}
          handleStepSet={this.handleStepSet}
          configuration={bikeConfiguration}
          step={step}
          actions={this.props.actions}
          isRiderFriendly={
            this.props.parameters.configuration === 'Rider Friendly'
          }
        />

        <div className='full-app' id='full-app'>
          <div
            ref={(node) => {
              this.controlBikes = node;
            }}
            className='app-container'
          >
            <GCContainer>
              <div>
                <Notes
                  text={
                    <div>
                      <p>
                        GoConfigure™ is a helpful estimating tool to provide you
                        with a layout based on the size of your project area,
                        for interior or exterior spaces.
                      </p>
                      <p>
                        Layouts provided are approximate estimates that will
                        help streamline planning your bicycle master plan and
                        should not be seen as final.
                      </p>
                    </div>
                  }
                />
              </div>
              <Waypoint
                scrollableAncestor={document.getElementById('full-app')}
                onEnter={(event) => {
                  if (this.state.step !== 0 && !disableWaypoint) {
                    // this.handleStepSet(0, true);
                  }
                }}
                onLeave={(event) => {
                  // console.log('keft', event);
                }}
              />
              <ControlSizeOrBikeCount
                step={step}
                handleStepSet={this.handleStepSet}
              />
              <div
                className='step-reminder'
                style={{
                  opacity:
                    step === 0 && !stepScrolled && !disableWaypoint ? 1 : 0,
                  height:
                    step === 0 && !stepScrolled && !disableWaypoint ? 44 : 0,
                  paddingTop: '20px',
                  transitionDelay:
                    step === 0 && !stepScrolled && !disableWaypoint
                      ? '1200ms'
                      : '0ms'
                }}
              >
                After entering your bike count or dimensions, click the "Next"
                button below.
              </div>

              <div
                ref={(node) => {
                  this.controlLayout = node;
                }}
                style={{
                  paddingTop: '20px'
                }}
              >
                <ControlLayout
                  {...this.props}
                  disableWaypoint={disableWaypoint}
                  scrolling={scrolling}
                  step={step}
                  handleScrollIn={() => {}}
                  handleScrollOut={() => {}}
                  scrollOut
                  handleStepSet={this.handleStepSet}
                />
              </div>
              <div
                ref={(node) => {
                  this.controlRacks = node;
                }}
                style={{
                  paddingTop: '20px'
                }}
              >
                <ControlRacks
                  {...this.props}
                  disableWaypoint={disableWaypoint}
                  scrolling={scrolling}
                  step={step}
                  handleScrollIn={() => {}}
                  handleScrollOut={() => {}}
                  handleStepSet={this.handleStepSet}
                />
              </div>
              <div
                ref={(node) => {
                  this.renderResults = node;
                }}
                style={{
                  paddingTop: '20px'
                }}
              >
                <RenderComponent
                  {...this.props}
                  scrolling={scrolling}
                  disableWaypoint={disableWaypoint}
                  configuration={configuration}
                  rack={rack}
                  uxPath={uxPath}
                  bikeConfiguration={bikeConfiguration}
                  marginAdds={marginAdds}
                  width={width}
                  pastWidth={pastWidth}
                  pastLength={pastLength}
                  length={length}
                  handleScrollIn={() => {}}
                  handleScrollOut={() => {}}
                  step={step}
                  handleStepSet={this.handleStepSet}
                />
              </div>
              <div
                ref={(node) => {
                  this.renderScene = node;
                }}
                style={{
                  paddingTop: '20px'
                }}
              >
                <Scene
                  scrolling={scrolling}
                  disableWaypoint={disableWaypoint}
                  configuration={bikeConfiguration}
                  handleScrollIn={() => {}}
                  handleScrollOut={() => {}}
                  step={step}
                  handleStepSet={this.handleStepSet}
                />
              </div>
              {isMobile && <ControlBigButton title='get quote' />}

              <div style={{ height: '200px', width: '100%' }} />
            </GCContainer>
          </div>
        </div>
      </div>
    ) : (
      <div />
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js